import { usePartnerConsentUserConsentByUserConsentQuery } from '../../data-access';

export const useUpdateUserConsents = () => {
	return usePartnerConsentUserConsentByUserConsentQuery();
};
